import {Component, HostListener, Input, OnInit, Output, EventEmitter} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ThemeService } from '@wind-log_library/fe-component-library';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponent implements OnInit {
    @Input() height: any;

    public width = '100%';
    public left = '0';
    public theme$: Observable<string>;
    constructor(private themeService: ThemeService) {}

  @HostListener('window:resize')
  onResize() {
    setTimeout(() => {
      const elmnt: any = document.getElementsByClassName('side-bar');
      this.width = (window.innerWidth - elmnt[0]?.offsetWidth ) + 'px';
      this.left = (elmnt[0]?.offsetWidth ) + 'px';
    }, 250);
  }

    ngOnInit() {
      this.theme$ = this.themeService.getTheme();
    }
}
